const AdminResponseZone = ({ response }) => {
    return (
        <div className='d-flex align-items-center flex-column justify-content-center'>
            <h1 className=''>{response?.response_status_code}</h1>
            <h4 className=''>{response?.response_status}</h4>
            <h6 className=''>{response?.response_error}</h6>
        </div>
    )
}
export default AdminResponseZone